import React, { useMemo, useState } from 'react';
import styles from './Header.module.css';
import BackButton from './BackButton';
import SettingsButton from './SettingsButton';
import VipButton from './VipButton';
import ReferalButton from './ReferalButton';
import Statistics from '../Statistics/Statistics';

const PHRASES_TARGET = 35000;
const WORDS_TARGET = 3000;

const Header = ({
  phrasesCount,
  learnedWordsCount = 0,
  audioTime = 100,
  vip,
  onSettingsClick,
  onVipClick,
  onRefClick,
  onBackClick,
}) => {
  const [showStatistics, setShowStatistics] = useState(false);
  const audioTimePercent = useMemo(() => {
    let multiplier;

    switch (vip) {
      case 0:
        multiplier = 1;
        break;
      case 1:
        multiplier = 3;
        break;
      case 2:
        multiplier = 4;
        break;
      case 3:
        multiplier = 7;
        break;
      default:
        multiplier = 15;
    }

    return Math.min(audioTime * multiplier, 100);
  }, [audioTime, vip]);

  return (
    <>
      <header className={styles.header}>
        <div className={styles.menuContainer}>
          <div className={styles.leftControls}>
            <BackButton onClick={onBackClick} />
            <SettingsButton onClick={onSettingsClick} />
          </div>

          <div className={styles.centerStats} onClick={() => setShowStatistics(true)}>
            <div className={styles.statItem}>
              <span className={styles.statIcon}>🗨️</span>
              <span>{phrasesCount.toLocaleString()} / {PHRASES_TARGET.toLocaleString()}</span>
            </div>
            <div className={styles.statItem}>
              <span className={styles.statIcon}>📚</span>
              <span>{learnedWordsCount.toLocaleString()} / {WORDS_TARGET.toLocaleString()}</span>
            </div>
          </div>

          <div className={styles.rightControls}>
            <VipButton vip={vip > 0} onClick={onVipClick} />
            <ReferalButton onClick={onRefClick} />
          </div>
        </div>
      </header>

      <div className={styles.audioProgressWrapper}>
        <div
          className={styles.audioProgressBar}
          style={{
            width: `${audioTimePercent}%`,
            backgroundColor:
              audioTimePercent < 15
                ? '#ef4444'
                : audioTimePercent < 30
                  ? '#facc15'
                  : '#22c55e',
          }}
        />
      </div>
      <Statistics isOpen={showStatistics} onClose={() => setShowStatistics(false)} />
    </>
  );
};

export default Header;
